import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {t("categories.title")}
        </h2>
        <p className="mt-3 text-base text-foreground-600">{t("categories.subtitle")}</p>
      </div>

      <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
        {categories.map((cat) => (
          <a
            key={cat.key}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="group overflow-hidden rounded-lg border border-background-300/60 bg-background-50 transition-colors hover:border-primary-300"
          >
            <div className="relative h-36 w-full overflow-hidden md:h-44">
              <img
                src={cat.image}
                alt={t(cat.key)}
                title={`${t(cat.key)} - USFans Spreadsheet`}
                className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
              />
            </div>
            <div className="flex items-center justify-between gap-2 p-3 md:p-4">
              <span className="whitespace-nowrap text-sm font-semibold text-foreground-900">
                {t(cat.key)}
              </span>
              <span className="flex h-5 w-5 shrink-0 items-center justify-center text-foreground-300 transition-colors group-hover:text-primary-500">
                <i className="ri-arrow-right-up-line text-base" />
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}